export default {
  'Choose File': 'Pilih File',
  'Please paste a URL': 'Silahkan paste URL',
  'Loading': 'Memuat',
  'Analyzing': 'Menganalisa',
  'Try a sample': 'Coba sampel',
  'Sorry, error occurs when analyzing the URL.': 'Maaf, error terjadi ketika menganalisa URL.',
  'Upload a photo': 'Unggah foto',
  "Drag and drop files to the upload box.": 'Geser dan lepas file ke kotak unggah.',
  'Please select the proper position with portrait.': 'Pilih posisi yang tepat dengan potret.',
  'downloading': 'Mengunduh',
}